import styled from 'styled-components'
// Styled component of MediaDetailsPopUp component.
/* --------------------------------------------- */
export const DetailsPagePopupHeader = styled.p`
  color: ${({ theme: { body } }) => body && body.text.primary};
`

export const BodyTextSecondary = styled.p`

  & span {
    color: ${({ metaTheme: { header } }) => header && header.text.secondary};
  }

  & span:before {
    background: ${({ metaTheme: { header } }) => header && header.text.secondary};
  }
`

export const DetailsPagePopupHeaderPrimary = styled.p`
  color: ${({ theme: { body } }) => body && body.text.secondary};
`

export const MetaBodyTextSecondary = styled.div`
  color: ${({ metaTheme: { body } }) => body && body.text.secondary};
`

export const MetaBodyTextTertiary = styled.div`
  color: ${({ metaTheme: { body } }) => body && body.text.tertiary};
  a {
    color: ${({ metaTheme: { body } }) => body && body.text.tertiary};
  }

  a:hover {
    color: ${({ metaTheme: { body } }) => body && body.accent.secondary};
  }
`

export const DetailsPageBadges = styled.ul`
.badges_wrapper{
  background-color: green
  display: flex;
  flex-direction: row;
  justify-content: space-evenly
}

  & p, & span{
    color: ${({ metaTheme: { header } }) => header && header.text.tertiary};
  }

  & li {
    border: solid 2px ${({ metaTheme: { header } }) => header && header.text.tertiary};
    color: ${({ metaTheme: { header } }) => header && header.text.tertiary};
  }

  & .filled {
    background: ${({ metaTheme: { header } }) => header && header.text.tertiary};
    color: ${({ metaTheme: { header } }) => header && header.text.tertiary};
  }
`
export const DescriptionText = styled.p`
  color: ${({ metaTheme: { header } }) => (header && header.text.primary)};
`
